import React from 'react';

const CohortLogo: React.FC = () => (
  <div className="flex items-baseline">
    <img
      src="https://storage.googleapis.com/cohort-prod-347206.appspot.com/assets/Cohort%20by%20Brevo%201.png"
      height={35}
      width={150}
      className="mr-20 min-w-[150px]"
      alt="Cohort Logo"
    />
  </div>
);
export default CohortLogo;
